/**
 * @description
 *
 * Возвращает преобразованную строку camelCase => kebab-case
 *
 * @param {string} str - строка, которую необходимо преобразовать
 *
 * @returns {string} - преобразованная строка
 */

function getKebabFromCamel(str) {
  return str.replace(/[A-Z]/g, (symbol, i) => (i === 0 ? symbol.toLowerCase() : `-${symbol.toLowerCase()}`))
}

export default getKebabFromCamel
